module.exports = __webpack_public_path__ + "static/media/IMG_4952.JPG - Version 2.e9aae3ac.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/IMG_4952.JPG - Version 2.JPG
// module id = 528
// module chunks = 0